import { Base } from "@/atoms-react/text/Text.react";
import { useTranslation } from "react-i18next";
import { Button } from "@/atoms-react/button/Button.react";
import { Themes } from "@/types/theme";
import { useState } from "react";
import { Modal } from "@/atoms-react/modal/index.react";
import { Buffer } from "buffer";

window.Buffer = window.Buffer || Buffer;
export const VideoCard = () => {
  const { t } = useTranslation(["pass"]);
  const [showVideo, setShowVideo] = useState<boolean>(false);
  const toggleVideoModal = () => setShowVideo((prev) => !prev);
  const olkyCardsClassName =
    "relative overflow-hidden w-full rounded-sm  h-[188px] lg:h-[188px] xl::h-[223px] 2xl:h-[223px]";
  const iframeStyles = {
    width: "50%",
    height: "50%"
  };

  const mobileStyles = {
    "@media (max-width: 768px)": {
      width: "100%",
      height: "100%"
    }
  };

  return (
    <>
      <div
        className={`${olkyCardsClassName} z-50 cursor-pointer bg-[#100629] hover:bg-opacity-85`}
        onClick={toggleVideoModal}
      >
        <div
          className={`h-full bg-[url('/images/olkypass/bg_discovery.png')] bg-contain px-4 py-4 md:px-4 md:py-4 lg:px-5 xl:py-6`}
        >
          <Base className="mt-2 text-left font-semibold text-white">
            {t("olkypass.mainPage.olkypass.bloc3.cardTitle")}
          </Base>
          <div className="flex h-full flex-col items-center items-center justify-center">
            <div className="h-10 w-10">
              <img src="/images/olkypass/play_icon.svg" alt="Play icon" />
            </div>
            <div className="w-full">
              <Button
                onClick={() => {
                  setShowVideo(true);
                }}
                size="md"
                theme={Themes.declarative}
                className="items-left mt-5 mb-6 h-8 w-auto w-auto truncate border-none bg-white text-black text-orange-500 text-xs sm:mt-5 sm:h-10 sm:w-96 sm:text-base lg:mt-8 lg:h-8 lg:text-sm xl:mt-5 xl:h-10 xl:text-base xl:text-lg 2xl:mt-14 dark:bg-white dark:text-black"
              >
                <span className="z-10 flex items-center justify-center space-x-2 overflow-hidden truncate text-ellipsis whitespace-nowrap text-sm sm:text-base">
                  <span className="truncate">{t("olkypass.mainPage.olkypass.bloc3.desc")}</span>
                </span>
              </Button>
            </div>
          </div>
          <Modal
            open={showVideo}
            onClose={() => setShowVideo(false)}
            style={{
              maxWidth: "90vw",
              maxHeight: "80vh",
              height: "calc(90vw* 0.580)"
            }}
          >
            {showVideo && (
              <iframe
                className="overflow-hidden rounded-md"
                title="Olky Presentation"
                src="https://www.youtube.com/embed/bR5-ajVO29I?autoplay=1"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                  ...iframeStyles,
                  ...mobileStyles["@media (max-width: 768px)"]
                }}
              ></iframe>
            )}
          </Modal>
        </div>
      </div>
    </>
  );
};
